// schema
// import * as ISchema from '@schema';

// libraries
import * as React from "react";
import { connect } from "react-redux";

// country-picker imports
import { IContainer, IProps, IState } from "./CountryPicker.d";
import { styles } from "./CountryPicker.styles";
import { countries, ICountry } from "./CountryPicker.util";

// state
import { IReduxState } from "@reducers/root.reducer";

// util
// import { getCurrentOrg } from '@util/org.util';

// material-ui
import { TextField } from "@material-ui/core";
import { Autocomplete, AutocompleteRenderInputParams } from "@material-ui/lab";
import withStyles from "@material-ui/core/styles/withStyles";

///////////////
// Component //
///////////////
class CountryPickerCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      selectedCountry: { code: "US", label: "United States", phone: "1", suggested: true },
    };
  }

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-
  private getOptionLabel = (option: ICountry) => {
    return option.label;
  };

  // ISO 3166-1 alpha-2
  // ⚠️ No support for IE 11
  private countryToFlag = (isoCode: string) => {
    return typeof String.fromCodePoint !== "undefined"
      ? isoCode
          .toUpperCase()
          .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
      : isoCode;
  };

  private onChange = (_e: any, option: ICountry) => {
    this.setState({ selectedCountry: option });
    this.props.onSelectCountry(option.code);
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  private renderOption = (option: ICountry) => {
    return (
      <React.Fragment>
        <span>{this.countryToFlag(option.code)}</span>
        {option.label}
      </React.Fragment>
    );
  };

  private renderInput = (params: AutocompleteRenderInputParams) => {
    // const { classes } = this.props;

    return (
      <TextField
        {...params}
        // label="Choose a country"
        placeholder="Country"
        variant="outlined"
        fullWidth
        InputLabelProps={{
          shrink: true,
        }}
        // InputProps={{ classes: { notchedOutline: classes.notchedOutline } }}
        inputProps={{
          ...params.inputProps,
          autoComplete: "new-password", // disable autocomplete and autofill
        }}
      />
    );
  };

  public render() {
    const { classes } = this.props;
    const { selectedCountry } = this.state;

    return (
      <Autocomplete
        id="country-select"
        options={countries}
        style={{ width: "100%" }}
        classes={{
          option: classes.option,
          inputRoot: classes.inputRoot,
          input: classes.input,
          root: classes.root,
        }}
        autoHighlight
        getOptionLabel={this.getOptionLabel}
        renderOption={this.renderOption}
        renderInput={this.renderInput}
        onChange={this.onChange}
        value={selectedCountry}
      />
    );
  }
}

/////////////////
// With Styles //
/////////////////
export const CountryPickerStyled = withStyles(styles)(CountryPickerCmpt);

///////////
// Redux //
///////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

export const CountryPicker = connect(mapStateToProps, {})(CountryPickerStyled);
